import { columns } from "@/components/tables/assets/columns";
import { DataTable } from "@/components/tables/assets/table";
import { httpClient } from "@/lib/http-client";
import { HydrationBoundary, useQuery } from "@tanstack/react-query";
import { useState } from "react";
import { useTranslation } from "@/lib/paraglide-react";
import { Route } from "/app/src/routes/{-$locale}/items/$id/assets.tsx";
function ItemAssetsPage() {
  const {
    t
  } = useTranslation();
  const {
    id
  } = Route.useParams();
  const [page, setPage] = useState({
    pageIndex: 0,
    pageSize: 20
  });
  const [filters, setFilters] = useState<ColumnFiltersState>([]);
  const {
    data: assets
  } = useQuery({
    queryKey: ["item", "assets", {
      id
    }],
    queryFn: () => httpClient.get<Asset[]>(`/items/${id}/assets`)
  });
  if (!assets) {
    return null;
  }
  return <div className="flex flex-col items-start justify-start h-full gap-4 w-full">
      <h2 className="text-xl font-bold">{t("items.assets.title")}</h2>
      <DataTable<Asset, unknown> columns={columns} data={assets} setPage={setPage} page={page} total={assets.length} filters={filters} setFilters={setFilters} />
    </div>;
}
const SplitComponent = () => {
  const {
    dehydratedState
  } = Route.useLoaderData() as {
    dehydratedState: DehydratedState;
    id: string;
  };
  return <HydrationBoundary state={dehydratedState}>
        <ItemAssetsPage />
      </HydrationBoundary>;
};
export { SplitComponent as component };